exports.params = {}
/**
 * Get URL query params from src in <script> tag
 * @returns JSON object
 */
exports.parse = () => {
  const scripts = document.getElementsByTagName("script")
  const index = scripts.length - 1
  const queryString = scripts[index].src.replace(/^[^?]+\??/, "")
  const pairs = queryString.split("&")

  pairs.forEach(pair => {
    const set = pair.split("=")
    exports.params[set[0]] = decodeURIComponent(set[1] || "")
  })
  return exports.params
}

// d_id, t_id and p_id are required
exports.isValid = () => exports.getDatabase() && exports.getTable() && exports.getPartnerId()

exports.get = key => {
  if (!exports.params) {
    this.parse()
  }
  return exports.params[key] || ""
}

exports.getDatabase = () => exports.get("d_id")

exports.getTable = () => exports.get("t_id")

exports.getPartnerId = () => exports.get("p_id")

exports.getCampaignId = () => exports.get("c_id")

exports.getMemberId = () => {
  let memberId = exports.get("member_id")

  if (!memberId) {
    memberId = exports.get("uid")
  }
  return memberId
}

exports.getAdid = () => exports.get("adid")

exports.getIdfa = () => exports.get("idfa")

exports.getPin = () => exports.get("pin")

exports.getCmpUa = () => exports.get("c_ua")

exports.getCmpT = () => exports.get("c_t")

exports.getCmpCi = () => exports.get("c_id") // Same as campaign_id
